  <template>
  		<!-- Header -->
		<div class="animated fadeIn">     
		           
		      

      <b-breadcrumb><h3>Design Samples</h3></b-breadcrumb>
      <div class="col-md-12" style='margin-top:10px;'>
		        	
          <div class="card" style="width:260px;float:left;margin-right:10px" v-for="designs in design_list" >
            
            <div class="card-body">
            <img style="height:200px;" class="card-img-top" v-bind:src="designs.design_image" alt="Card image cap">
              <h5 class="card-title text-center pt-4" >{{designs.design_title}}</h5>

              <!--<p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>-->

              <!--<a href="#" class="btn btn-primary">Go somewhere</a>-->

              <span style="float:right">

              <!--
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template v-slot:button-content>
                    <span class="cui-options icons font-1xl d-block"></span>
                  </template>
                  <b-dropdown-item 
                  :href="'/designdetail/' + designs.design_id"
                  >View Detail</b-dropdown-item>

                  

                  <b-dropdown-item href="#">Send Quote</b-dropdown-item>
                  
                </b-dropdown> -->

                <router-link v-bind:to="'/designdetail/' + designs.design_id">View Detail</router-link> 
              </span>               

            </div>


          </div>




		        </div>

        </div> 

  </template>

<style>
.c-avatar-img {
    width: 100%;
    height: auto;
    border-radius: 50em;
}	
.card-body {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.0rem;
}
</style>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'

const axios = require('axios')


export default {
  name: 'Cards',
  data: function () {
    return {
      sampelAddModal: false,
     
      show: true,
      isCollapsed: true,
      design_list:[],
      collection_title:''
      
    }
  },
  created: function() {  
    this.getDesignSampleList();
    
   
  },

  methods: {      

    /****** Function to Get Design Sample List ********/
    getDesignSampleList: function () {

        this.isBusy = true;

       
        axios.post(`${CONSTANTS.API_URL}/getdesignsamplelist`,{})
        .then(response => {
          // JSON responses are automatically parsed.
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {

            this.design_list  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;

            
            this.isBusy = !this.isBusy;
            
          }else {
           this.design_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })


    },



  }


}
</script>
